import { EVENT_MAP_ICON_TYPE } from 'utils/constants/Map';
import { serviceTypes, SERVICE_ICON } from './constants/serviceTypes';
import { TASK_TYPE } from './constants/task';

const patrolIcon = require('../images/icon_service_patrol.svg');
const newsPerimeterIcon = require('images/icon_news_perimeter_marker.svg');
const nonNewsPerimeterIcon = require('images/icon_incident_perimeter_marker.svg');
const newsOverlay = require('images/icon_news_overlay.svg');
const incidentOverLay = require('images/icon_Incident_overlay.svg');
const transport = require('../images/icon_service_transportation.svg');

export const images = {
  srmLogo: require('images/srm_portal_logo_small.svg'),
  msgIcon: require('images/icon_message.svg'),
  replyIcon: require('images/icon_reply.svg'),
  editIcon: require('images/new/edit.svg'),
  closePanel: require('images/icon_close.svg'),
  emptyProfile: require('images/icon_add_profile_image.svg'),
  emptyEstablishment: require('images/icon_add_image.svg'),
  iconDistress: require('images/icon_distress.svg'),
  iconOperationalView: require('images/icon_operational_view.svg'),
  iconManagerialView: require('images/icon_managerial_view.svg'),
  iconReportingView: require('images/icon_reporting_view.svg'),
  iconSecurityManagerView: require('images/icon_account_view.svg'),
  iconRegionManagerView: require('images/icon_map.svg'),
  iconTransportView: require('images/icon_transport_view.svg'),
  iconLogout: require('images/icon_log_out.svg'),
  iconSite: require('images/icon_site_location_marker.svg'),
  warning: require('../images/icon_status_orange.svg'),
  success: require('../images/icon_status_green.svg'),
  onDuty: require('../images/icon_service_armed.svg'),
  offDuty: patrolIcon,
  completedPatrol: require('../images/icon_shield.svg'),
  tickIcon: require('../images/icon_search.svg'),
  yes: require('../images/icon_service_distress.svg'),
  no: require('../images/icon_cross.svg'),
  EMERGENCY: require('../images/icon_service_distress.svg'),
  TRANSPORT: transport,
  EMERGENCY_STANDARD: require('../images/icon_service_distress.svg'),
  EMERGENCY_ARMED: require('../images/icon_service_armed.svg'),
  PROTECTION: require('../images/icon_service_distress.svg'),
  CANINE_HANDLING: require('../images/icon_asset_canine.svg'),
  ARMED_TRANSPORT: require('../images/icon_service_armed.svg'),
  ARMED_RESPONSE: require('../images/icon_service_armed.svg'),
  ARMED_PROTECTION: require('../images/icon_service_armed.svg'),
  //PATROL: patrolIcon,
  [serviceTypes.transport.standard]:
    SERVICE_ICON[serviceTypes.transport.standard],
  [serviceTypes.transport.secure]: SERVICE_ICON[serviceTypes.transport.secure],
  [serviceTypes.visitorManagement]:
    SERVICE_ICON[serviceTypes.visitorManagement],
  [serviceTypes.crowdManagement]: SERVICE_ICON[serviceTypes.crowdManagement],
  [serviceTypes.cleaning]: SERVICE_ICON[serviceTypes.cleaning],
  [serviceTypes.maintenance]: SERVICE_ICON[serviceTypes.maintenance],
  [serviceTypes.patrol.singleSite]:
    SERVICE_ICON[serviceTypes.patrol.singleSite],
  [serviceTypes.patrol.multiSite]: SERVICE_ICON[serviceTypes.patrol.multiSite],

  //ASSET-TYPE
  CANINE: require('../images/icon_asset_canine.svg'),
  FIREARM: require('../images/icon_asset_firearm.svg'),
  PHONE: require('../images/icon_asset_phone.svg'),
  VEHICLE: require('../images/icon_asset_vehicle.svg'),
  VEHICLE_OFF_ROAD: require('../images/icon_asset_vehicle.svg'),
  VEHICLE_VAN: require('../images/icon_asset_vehicle.svg'),
  VEHICLE_BUS: require('../images/icon_asset_vehicle.svg'),
  OTHER: require('../images/icon_asset.svg'),
  CAR: require('../images/icon_transport_responder.svg'),
  PASSENGER_NORMAL: require('../images/icon_customer.png'),
  SITE: require('../images/icon_asset_site.svg'),
  // user statuses
  ON_INTERRUPTABLE_TASK: require('images/icon_user_interruptabletask.svg'),
  AVAILABLE: require('images/icon_user_available.svg'),
  UNAVAILABLE: require('images/icon_user_unavailable.svg'),
  ON_TASK: require('images/icon_user_ontask.svg'),
  IN_USE: require('images/icon_status_in_use.svg'),
  RETURNING: require('images/icon_status_return.svg'),
  NOT_LOGGED_IN: require('images/icon_user_notloggedin.svg'),
  /**
   *TODO: remove INACTIVE it as it is not correct status
   */
  INACTIVE: require('images/icon_cross.svg'),
  ON_BREAK: require('images/icon_user_onbreak.svg'),
  //----------------------------------------------------
  DEPLOYING: require('images/icon_status_deploy.svg'),
  REGISTERED: require('images/icon_status_green.svg'),
  UNREGISTERED: require('images/icon_cross.svg'),
  // map
  addLocation: require('images/icon_add_location_info.svg'),
  addPoint: require('images/icon_add_location_point.svg'),
  addPolygon: require('images/icon_add_polygon_perimeter.svg'),
  addSquare: require('images/icon_add_square_perimeter.svg'),
  addCircle: require('images/icon_add_circle_perimeter.svg'),
  // map-icons
  patrol: require('images/icon_patrol.svg'),
  sitePatrol: require('images/icon_service_site_patrol.svg'),
  distress: require('images/icon_distress.svg'),

  //Personnel icons for Map
  client: require('images/icon_customer.png'),
  customer: require('images/icon_customer.png'),
  'distress-client': require('images/icon_distress_customer.png'),
  'distress-customer': require('images/icon_distress_customer.png'),
  responder: require('images/icon_responder.png'),
  responderOverlay: require('images/icon_round_responder_overlay.svg'),
  'distress-responder': require('images/icon_distress_responder.png'),
  'distress-maintainer': require('images/icon_distress_maintainer.png'),
  guard: require('images/icon_guard.png'),
  guardOverlay: require('images/icon_round_guard_overlay.svg'),
  'distress-guard': require('images/icon_distress_guard.png'),
  operator: require('images/icon_operator.svg'),
  operatorOverlay: require('images/icon_round_operator_overlay.svg'),
  cleaner: require('images/icon_cleaner_round.png'),
  cleanerOverlay: require('images/icon_round_cleaner_halo.png'),
  maintainer: require('images/icon_maintainer_round.png'),
  maintainerOverlay: require('images/icon_maintainer_round_halo.svg'),

  //Event icons for Map
  news: newsPerimeterIcon,
  others: nonNewsPerimeterIcon,
  [EVENT_MAP_ICON_TYPE.NEWS_EVENT_SINGLE_LOC]: require('images/icon_news_single_location_point.svg'),
  [EVENT_MAP_ICON_TYPE.NEWS_EVENT_MULTI_LOC]: require('images/icon_news_first_location_point.svg'),
  [EVENT_MAP_ICON_TYPE.NON_NEWS_EVENT_SINGLE_LOC]: require('images/icon_incident_single_location_point.svg'),
  [EVENT_MAP_ICON_TYPE.NON_NEWS_EVENT_MULTI_LOC]: require('images/icon_incident_first_location_point.svg'),
  [EVENT_MAP_ICON_TYPE.NEWS_EVENT_POLYGON]: newsPerimeterIcon,
  [EVENT_MAP_ICON_TYPE.NON_NEWS_EVENT_POLYGON]: nonNewsPerimeterIcon,
  [EVENT_MAP_ICON_TYPE.NON_NEWS_EVENT_SINGLE_LOC_OVERLAY]: incidentOverLay,
  [EVENT_MAP_ICON_TYPE.NEWS_EVENT_SINGLE_LOC_OVERLAY]: newsOverlay,
  [EVENT_MAP_ICON_TYPE.NEWS_EVENT_POLYGON_OVERLAY]: newsOverlay,
  [EVENT_MAP_ICON_TYPE.NON_NEWS_EVENT_POLYGON_OVERLAY]: incidentOverLay,
  [EVENT_MAP_ICON_TYPE.NEWS_EVENT_MULTI_LOC_OVERLAY]: newsOverlay,
  [EVENT_MAP_ICON_TYPE.NON_NEWS_EVENT_MULTI_LOC_OVERLAY]: incidentOverLay,
  [EVENT_MAP_ICON_TYPE.NEWS_EVENT_ELLIPSE]: newsPerimeterIcon,
  [EVENT_MAP_ICON_TYPE.NEWS_EVENT_ELLIPSE_OVERLAY]: newsOverlay,
  [EVENT_MAP_ICON_TYPE.NON_NEWS_EVENT_ELLIPSE]: nonNewsPerimeterIcon,
  [EVENT_MAP_ICON_TYPE.NON_NEWS_EVENT_ELLIPSE_OVERLAY]: incidentOverLay,

  // media
  addMedia: require('images/icon_add_item.svg'),
  playMedia: require('images/icon_play.svg'),
  pauseMedia: require('images/icon_pause.svg'),
  imageMedia: require('images/icon_image_media.svg'),
  audioMedia: require('images/icon_audio_media.svg'),
  downloadMedia: require('images/icon_arrow_down.svg'),
  //Trip
  NEW: require('images/icon_cross.svg'),
  RESOLVED: require('images/icon_status_green.svg'),
  RESOLVED_EMERGENCY: require('images/icon_status_green.svg'),
  RESOLVED_ABORTED: require('images/icon_status_green.svg'),
  RESOLVED_CANCELLED: require('images/icon_status_green.svg'),
  NEW_ASSIGNED: require('images/icon_status_orange.svg'),
  IN_PROGRESS_EN_ROUTE: require('images/icon_status_orange.svg'),
  IN_PROGRESS_ON_SITE: require('images/icon_status_orange.svg'),
  IN_PROGRESS_SAFE_ON_SITE: require('images/icon_status_orange.svg'),
  IN_PROGRESS_VISUAL_CONTACT: require('images/icon_status_orange.svg'),
  IN_PROGRESS_PASSENGER_VERIFIED: require('images/icon_status_orange.svg'),
  IN_PROGRESS_TRIP_EN_ROUTE: require('images/icon_status_orange.svg'),
  IN_PROGRESS_TRIP_DESTINATION_ON_SITE: require('images/icon_status_orange.svg'),
  IN_PROGRESS_TRIP_DESTINATION_SAFE_ON_SITE: require('images/icon_status_orange.svg'),
  IN_PROGRESS_TRIP_PASSENGER_DROPPED_OFF: require('images/icon_status_orange.svg'),
  //filter
  submit: require('images/icon_submit.svg'),
  reset: require('images/icon_reset.svg'),
  // Cleaning task
  [TASK_TYPE.CLEANING.mapIcon]: require('images/icon_turquoise_teardrop.svg'),
  [`${TASK_TYPE.CLEANING.mapIcon}Overlay`]: require('images/icon_turquoise_teardrop_halo.svg'),

  // Maintenance task
  [TASK_TYPE.MAINTENANCE.mapIcon]: require('images/icon_teardrop_purple.svg'),
  [`${TASK_TYPE.MAINTENANCE.mapIcon}Overlay`]: require('images/icon_teardrop_purple_halo.svg'),
  //security tasks
  [TASK_TYPE.SECURITY.mapIcon]: require('images/icon_security_task.svg'),
  [`${TASK_TYPE.SECURITY.mapIcon}Overlay`]: require('images/icon_security_task_halo.svg'),
  imageMediaPlaceholder: require('images/icon_image_placeholder.svg'),
  audioMediaPlaceholder: require('images/icon_audio_media_placeholder.svg'),
  checkboxPlaceholder: require('images/icon_yes_placeholder.svg'),
  checkbox: require('images/icon_yes_green.svg'),
  content: require('images/icon_content.svg'),
  qrcode: require('images/icon_qrcode.svg'),
  addressMarker: require('images/icon_incident_single_location_point.svg'),
};
